// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {find, get} from 'lodash';

// Components
import Button from '../core/button';
import Icon from '../core/icon';
import Permissions from '../core/permissions';
import TooltipTrigger from '../core/tooltip-trigger';

// Redux Actions
import {checkLockedRecords, lockOverride} from '../../actions/record-locking-actions';

// Styles
import './locked-indicator.scss';

class LockedIndicator extends Component {
    getClass() {
        const {className, detail} = this.props;

        return classnames(
            {
                'locked-indicator': true,
                'locked-indicator_detail': detail,
            },
            className
        );
    }

    getLockedRecord = () => {
        const {lockId, lockedRecords, serviceKey} = this.props;
        const serviceLockedRecords = get(lockedRecords, serviceKey);

        return find(serviceLockedRecords, ['recordId', lockId]);
    };

    handleCheckClick = (event) => {
        if (event) {
            event.stopPropagation();
        }

        const {checkLockedRecords} = this.props;

        checkLockedRecords();
    };

    handleUnlockClick = (event) => {
        if (event) {
            event.stopPropagation();
        }

        const {lockId, lockOverride, serviceKey} = this.props;

        lockOverride({recordIds: [lockId], serviceKey});
    };

    renderDetail() {
        const {authUser, lockId, recordLabel} = this.props;
        const {username} = this.getLockedRecord() || {};

        return lockId && username ? (
            <div className={this.getClass()}>
                <Icon
                    className={`locked-indicator--${authUser !== username ? 'icon-other' : 'icon'}`}
                    fontType="fa"
                    iconName="lock"
                />
                {recordLabel || 'Record'} currently locked by {username}
                {this.renderLockOverrideButton(username)}
            </div>
        ) : (
            <Permissions accessRequirement="write">
                <div className={this.getClass()}>
                    <Icon className="locked-indicator--icon" fontType="fa" iconName="unlock-alt" />
                    {recordLabel || 'Record'} currently not locked.
                </div>
            </Permissions>
        );
    }

    renderLock() {
        const {authUser, lockId} = this.props;
        const {username} = this.getLockedRecord() || {};

        return lockId && username ? (
            <TooltipTrigger className={this.getClass()} tooltipRenderer={this.renderTooltip}>
                <Icon
                    className={`locked-indicator--${authUser !== username ? 'icon-other' : 'icon'}`}
                    fontType="fa"
                    iconName="lock"
                />
            </TooltipTrigger>
        ) : null;
    }

    renderLockOverrideButton(username) {
        const {authUser} = this.props;

        return username && authUser !== username ? (
            <Permissions accessRequirement="write">
                <Button className="locked-indicator--button" small={true} onClick={this.handleUnlockClick}>
                    Override Lock
                </Button>
            </Permissions>
        ) : null;
    }

    renderTooltip = () => <div className="locked-indicator--tooltip">Locked by {this.getLockedRecord().username}</div>;

    render() {
        const {detail} = this.props;

        return detail ? this.renderDetail() : this.renderLock();
    }
}

LockedIndicator.propTypes = {
    authUser: PropTypes.string,
    checkLockedRecords: PropTypes.func.isRequired,
    className: PropTypes.string,
    detail: PropTypes.bool,
    lockedRecords: PropTypes.object,
    lockId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lockOverride: PropTypes.func.isRequired,
    recordLabel: PropTypes.string,
    serviceKey: PropTypes.string.isRequired,
};

const mapStateToProps = ({auth, recordLocking}) => ({
    lockedRecords: recordLocking.lockedRecords,
    authUser: auth.user,
});

const mapDispatchToProps = {
    checkLockedRecords,
    lockOverride,
};

export default connect(mapStateToProps, mapDispatchToProps)(LockedIndicator);
